import { Form } from '@juvare/common-form-ui/Form';
import { defaultFormWidgets } from '@juvare/common-form-ui/WidgetForm';
import { Box } from '@mui/material';
import React from 'react';
import { alertFormWidgets } from '../../../form-widgets';
export const FormComponent = React.forwardRef((props, ref) => {
    const formComponentRef = React.useRef(null);
    React.useImperativeHandle(ref, () => ({
        getData: () => {
            var _a, _b;
            return (_b = (_a = formComponentRef.current) === null || _a === void 0 ? void 0 : _a.getData()) !== null && _b !== void 0 ? _b : {};
        },
        submit: () => {
            var _a;
            if (formComponentRef.current) {
                return (_a = formComponentRef.current) === null || _a === void 0 ? void 0 : _a.submit();
            }
            return Promise.resolve();
        },
    }));
    return (React.createElement(AlertForm, { data: props.data, ref: formComponentRef, form: props.form, onChanged: props.onChanged, onSubmit: props.onSubmit, onSubmitSuccess: props.onSubmitSuccess, hideFormControls: props.hideFormControls }));
});
const AlertForm = React.forwardRef((props, ref) => {
    const formRef = React.useRef(null);
    React.useImperativeHandle(ref, () => ({
        getData: () => {
            var _a, _b;
            return (_b = (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.getData()) !== null && _b !== void 0 ? _b : {};
        },
        submit: () => {
            var _a;
            if (formRef.current) {
                return (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.submit();
            }
            return Promise.resolve();
        },
    }));
    return (React.createElement(Box, { sx: { display: 'flex', flexGrow: 1, height: '100%' } },
        React.createElement(Box, { sx: {
                width: '100%',
                px: { xs: 2, sm: 4, xl: 5 },
                py: { xs: 2, sm: 4 },
                overflow: 'auto',
            } },
            React.createElement(Form, { ref: formRef, config: props.form, onChanged: props.onChanged, onSubmit: props.onSubmit, onSubmitSuccess: props.onSubmitSuccess, hideFormControls: props.hideFormControls, data: props.data, widgets: [...defaultFormWidgets, ...alertFormWidgets] }))));
});
